import { defineStore } from 'pinia';
import { ref, inject, computed } from 'vue';

function allProductHashes() {
  const hashes = JSON.parse(process.env.HASH_PRODUCTS);
  const plans = Object.keys(hashes);

  return plans.reduce((accum, plan) => {
    const planKeys = Object.keys(hashes[plan]);

    planKeys.forEach((key) => {
      const hash = hashes[plan][key];
      if (typeof hash === 'object') {
        accum.push(...hash);
      } else {
        accum.push(hash);
      }
    });

    return accum;
  }, []);
}

export const useProductStore = defineStore('product', () => {
  const axios = inject('axios');

  const products = ref(null);
  const currentProduct = ref(null);

  const userPlan = computed(() => {
    if (!currentProduct.value) {
      return 'free';
    }

    const hashes = JSON.parse(process.env.HASH_PRODUCTS);
    const plans = Object.keys(hashes);

    const plan = plans.find((item) => {
      const hashesArray = [hashes[item].regular, hashes[item].sale];
      if (hashes[item].old) {
        hashesArray.push(...hashes[item].old);
      }
      return hashesArray.includes(currentProduct.value.product.hash);
    });

    return plan || 'free';
  });
  const upgradeLinks = computed(() => currentProduct.value.product.upgradeLinks);

  async function getUpgradeLinks() {
    const { data } = (await axios.get('/products/system/upgrade/links')).data;
    const activeItems = data.filter((item) => item.isActive);
    const allHashes = allProductHashes();

    currentProduct.value = activeItems.find((item) => allHashes.includes(item.product.hash));
  }

  async function getAllProducts() {
    const { data } = (await axios.get('/products/system')).data;
    products.value = data;
  }

  return {
    products,
    currentProduct,
    upgradeLinks,
    userPlan,
    getUpgradeLinks,
    getAllProducts,
  };
});
